import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { CompanyGroup } from '../types'

interface CompanyGroupState {
    loading: boolean
    companyGroup: CompanyGroup | null
    error: Error | string | null
}

const initialState: CompanyGroupState = {
    loading: false,
    companyGroup: null,
    error: null
}

export const companyGroupSlice = createSlice({
    name: 'companyGroup',
    initialState,
    reducers: {
        loading: state => {
            state.loading = true
            state.error = null
        },
        companyGroupFetched: (state, action: PayloadAction<CompanyGroup>) => {
            state.loading = false
            state.companyGroup = action.payload
            state.error = null
        },
        companyGroupFetchFailure: (state, action: PayloadAction<Error | string>) => {
            state.loading = false
            state.error = action.payload
        }
    }
})

export const { 
    loading, 
    companyGroupFetched, 
    companyGroupFetchFailure,
} = companyGroupSlice.actions

export default companyGroupSlice.reducer